import styled, { keyframes } from 'styled-components';
import React, { useState, useEffect, createRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

const marquee = (x: number) => keyframes`
  0% {
    left: 100%;
  }
  100% {
    left: -${(x || 0) + 10}px;
  }
`
const Container = styled.div<{hasIcon: boolean}>`
  display: flex;
  align-items: center;
  padding: 10px;
  [data-icon] {
    width: ${props => props.hasIcon ? '30px' : 'auto'}
  }
  & [color=primary] {
    color: ${props => props.theme.COLOR_PRIMARY}
  }
  & [color=success] {
    color: ${props => props.theme.COLOR_SUCCESS}
  }
  & [color=error] {
    color: ${props => props.theme.COLOR_ERROR}
  }
  & [color=info] {
    color: ${props => props.theme.COLOR_INFO}
  }
  & [color=warn] {
    color: ${props => props.theme.COLOR_WARN}
  }
`
const Inner = styled.div<{dataWidth: number}>`
  width: 2000px;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  transform: translate3d(0, 0, 0);
  animation: ${props => marquee(props.dataWidth || 0)} 50s linear infinite;
  & > * {
    display: inline-block;
    padding-right: 15px;
    line-height: 30px;
  }
`
const Wrapper = styled.div.attrs({
  'data-widget': 'infinite-scrolling'
})`
  flex: 1;
  height: 30px;
  line-height: 30px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  transform: translate3d(0, 0, 0);
  white-space: nowrap;
  &:hover ${Inner} {
    animation-play-state: paused;
  }
`
interface Props {
  items?: string[],
  icon?: IconProp,
  iconColor?: string,
  color?: string,
  children?: React.ReactNode
}
const InfiniteScrolling = (props: Props) => {
  const { items, icon, color, children } = props;
  const [ width, setWidth ] = useState<number>(0)
  let selectRef = createRef<HTMLDivElement>();
  useEffect(() => {
    if (selectRef.current && selectRef.current.children) {
      const elements: Element[] = Array.from(selectRef.current.children);
      let totalWidth: number = elements.reduce((res, ele: Element) => res + ele.clientWidth, 0)
      // console.log('totalWidth', totalWidth)
      setWidth(totalWidth)
    }
  }, [selectRef])
  return <Container hasIcon={!!icon}>
    {icon ? <FontAwesomeIcon icon={icon} color={color} /> : null}
    <Wrapper>
      <Inner ref={selectRef} dataWidth={width}>
        {items?.length ? items.map((item, i) => <span key={i}>{item}</span>) : children}
      </Inner>
    </Wrapper>
  </Container>
}
export default InfiniteScrolling;